import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventService, JobsService } from '../../../services';
import { IBasicJobData } from '../../../interfaces/telephony/basic-job-data.dto.interface';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IBasicOrganisationInfo } from '../../../interfaces/telephony/basic-organisation-info';
import { OrganisationSelectorEventTypeEnum } from '../../../interfaces/telephony/organisation-selector-event-type.enum';
import { OrganisationTypeEnum } from '../../../enums/organisation-types';

@Component({
  selector: 'add-number-job-search',
  templateUrl: './add-number-job-search.component.html',
  styleUrls: ['./add-number-to-organisation.component.scss'],
})
export class AddNumberJobSearchComponent implements OnInit, OnDestroy {
  jobInfos: IBasicJobData[];
  searchText: any;

  hoverMore: number;
  selectedRow: number = -1;
  isBusy = false;

  private searchSubject: Subject<string> = new Subject();

  constructor(private jobService: JobsService, private eventService: EventService) {}

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchText) => {
      this.searchJobs(searchText);
    });
  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
  }

  searchJobs(text: string) {
    // load all organisation information once on start
    this.isBusy = true;
    this.jobService
      .searchJobsByReg(text)
      .then((res) => {
        this.jobInfos = res;
        this.isBusy = false;
      })
      .catch(() => {
        this.isBusy = false;
      });
  }

  searchTextChanged(text: string): void {
    text = text || '';
    this.searchText = text;

    if (this.searchText.length >= 3) {
      this.searchSubject.next(this.searchText);
    }
  }

  jobSelected(job: IBasicJobData, i: number) {
    this.selectedRow = i;
  }

  organisationSelected(job: IBasicJobData, isCustomer: boolean) {
    let userCount = isCustomer ? job.customerUsers?.length : job.supplierUsers?.length;
    let org = isCustomer ? job.customer : job.supplier;
    org.users = isCustomer ? job.customerUsers : job.supplierUsers;

    let eventType =
      userCount > 1
        ? OrganisationSelectorEventTypeEnum.OpenUserSelector
        : OrganisationSelectorEventTypeEnum.AssociateOrganisationSelected;

    // close user selector if no users in selected org
    if (userCount == 1) {
      this.eventService.OrganisationSelectorEvent.emit({
        eventType: OrganisationSelectorEventTypeEnum.CloseUserSelector,
        args: null,
      });
    }

    this.eventService.OrganisationSelectorEvent.emit({
      eventType: eventType,
      args: { selectedOrg: org },
    });
  }
}
